import { routes, EligibilityRoutes } from "../../Routes";

export enum PropertyType {
  Own = "own",
  Rented = "rented"
}

export const EligibilityViewConstants = {
  labels: {
    eligibilitySteps: [
      {
        stepTitle: "Describe your company",
        route: routes.eligibility.view(EligibilityRoutes.CompanyFold)
      },
      {
        stepTitle: "About yourself",
        route: routes.eligibility.view(EligibilityRoutes.ApplicantFold)
      },
      {
        stepTitle: "Receivables details",
        route: routes.eligibility.view(EligibilityRoutes.ReceivablesFold)
      },
      {
        stepTitle: "Eligibility amount",
        route: routes.eligibility.view(EligibilityRoutes.EligibilityAmountFold)
      }
    ],
    topbarSteps: [
      {
        stepTitle: "Eligibility",
        route: routes.eligibility.view(EligibilityRoutes.EligibilityAmountFold),
        fold: ""
      },
      {
        stepTitle: "Account Details",
        route: routes.eligibility.bankAccountDetails,
        fold: "bank-account-details"
      },
      {
        stepTitle: "Upload Documents",
        route: routes.eligibility.kyc,
        fold: "kyc"
      }
    ],
    keyCustomersTooltip:
      "You can fill your customers here as well as on your profile section",
    keySuppliersTooltip:
      "You can fill your suppliers here as well as on your profile section"
  }
};
